import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "causeId" ] 

  selectCause(e) {
    this.causeIdTarget.value = e.currentTarget.dataset.id;
  }
}